import { useContributorStore } from "@/store/modules/contributor";
import { useMissionStore } from "@/store/modules/mission";
import { usePreparationStore } from "@/store/modules/preparation";
import { useAdditionalMaterialStore } from "@/store/modules/additionalsMaterial";

export default async (to, from, next) => {
  try {
    const contributorsStore = useContributorStore();
    const missionsStore = useMissionStore();
    const preparationStore = usePreparationStore();
    const additionalsMaterialStore = useAdditionalMaterialStore();

    await contributorsStore.fetchContributors({
      projectUuid: to.params.missionId,
    });
    await missionsStore.retrieveMission(to.params.missionId);
    await preparationStore.retrievePreparationByMission(to.params.missionId);
    const preparationData = preparationStore.getCurrentPreparation;
    if (!preparationData.materials) return next();
    await preparationStore.fetchValidatedMaterials();
    await additionalsMaterialStore.fetchAdditionalsMaterialByPreparation(preparationData.uuid);

    return next();
  } catch (err) {
    console.log(err);
    return next();
  }
};
